// ScrollToTop.js - Component to restore scroll position on route changes
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Guard against non-browser environments (SSR/tests)
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    // Scroll to top when pathname changes
    const isJsDom =
      typeof navigator !== 'undefined' &&
      typeof navigator.userAgent === 'string' &&
      navigator.userAgent.toLowerCase().includes('jsdom');

    if (!isJsDom && typeof window.scrollTo === 'function') {
      try {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant'
        });
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn('ScrollToTop: window.scrollTo not available.', error);
        }
      }
    }

    // Also ensure document body scroll is reset
    if (document.body && document.body.scrollTop !== 0) {
      document.body.scrollTop = 0;
    }

    // And document element scroll is reset
    if (document.documentElement && document.documentElement.scrollTop !== 0) {
      document.documentElement.scrollTop = 0;
    }
  }, [pathname]);

  return null;
}